import { Suspense } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useUser } from "context/AuthContext";
import Paths from "./Paths";

import Loader from "components/general/Loader";
import DocTypeContextProvider from "context/DocTypeContext";
import MainLayout from "layouts/MainLayout";

export default function ProtectedRoute({ need_auth }: { need_auth?: boolean }) {

   const user = useUser();

   if ( need_auth ) {
      return user.id ? (
         <DocTypeContextProvider> 
            <MainLayout> 
               <Suspense fallback={ <Loader height={300}/>}> 
                  <Outlet/> 
               </Suspense>
            </MainLayout>
         </DocTypeContextProvider>
       ) : <Navigate to={ Paths.Auth.Login }/> 
   } 
   
   if ( !need_auth && user.id ) return <Navigate to={ Paths.Home }/>

   return <Suspense fallback={ <Loader style={{ height: "100vh" }}/>}> <Outlet/> </Suspense>
}